export const DOTS = "..." as const;
